import App from 'app/app.js';
import 'app/directive/LtLookCarouselCtrl.js';

function LtLookCarouselDirective() {
  return {
    restrict: 'E',
    scope: {
      confirm: '&',
      onGoFavoriteLooks: '&',
      currentItemDesc: '='
    },
    template:
      '<div id="carousel-cart-look" class="carousel slide look-carousel" ng-init="lookCarousel.init()">' +
      '    <ol class="carousel-indicators">' +
      '        <li ng-repeat="(key, value) in lookCarousel.rowViews" ng-click="lookCarousel.pageIndex = key" ng-class="{active: key==lookCarousel.pageIndex}"></li>' +
      '    </ol>' +
      '    <div class="carousel-inner">' +
      '        <div class="item" ng-class="{active: key==lookCarousel.pageIndex}" ng-repeat="(key, rowView) in lookCarousel.rowViews">' +
      '            <div class="row" ng-swipe-right="lookCarousel.prevPage()" ng-swipe-left="lookCarousel.nextPage()"> ' +
      '                <div ng-show="rowView.hasLooks">' +
      '                    <div ng-repeat="(key, colView) in rowView.colViews">' +
      '                        <div ng-show="colView.look" class="col-xs-4">' +
      '                            <div class="carousel-item">' +
      '                                <img lt-look-loader="colView.look" ng-click="lookCarousel.selectLook($event, colView.look)" class="photo should-stay-blocked" />' +
      '                            </div>' +
      '                        </div>' +
      '                        <div ng-hide="colView.look" class="col-xs-{{rowView.colViews.length === 2 ? 8 : 4}}">' +
      '                            <div class="row carousel-item">' +
      '                                <div class="fav-txt" lt-translate="SELECT_LOOK_CAROUSEL_FAVORITE_TEXT_SMALL"></div>' +
      '                                <div class="fav-btn fav-btn-sm" ng-click="lookCarousel.goToPortraitLooks()" lt-translate="SELECT_LOOK_CAROUSEL_FAVORITE_BUTTON_SMALL"></div>' +
      '                            </div>' +
      '                        </div>' +
      '                    </div>' +
      '                </div>' +
      '                <div ng-hide="rowView.hasLooks">' +
      '                    <div class="col-xs-12">' +
      '                        <div class="row carousel-item">' +
      '                            <div class="fav-txt" lt-translate="SELECT_LOOK_CAROUSEL_FAVORITE_TEXT"></div>' +
      '                            <div class="fav-btn" ng-click="lookCarousel.goToPortraitLooks()" lt-translate="SELECT_LOOK_CAROUSEL_FAVORITE_BUTTON"></div>' +
      '                        </div>' +
      '                    </div>' +
      '                </div>' +
      '            </div>' +
      '        </div>' +
      '    </div>' +
      '    <a class="left carousel-control" ng-click="lookCarousel.prevPage()">' +
      '        <lt-icon name="fa-sharp-solid-chevron-left" class="fa-chevron-left" aria-hidden="true"></span>' +
      '        <span class="sr-only">Previous</span>' +
      '    </a>' +
      '    <a class="right carousel-control" ng-click="lookCarousel.nextPage()">' +
      '        <lt-icon name="fa-sharp-solid-chevron-right" class="fa-chevron-right" aria-hidden="true"></span>' +
      '        <span class="sr-only">Next</span>' +
      '    </a>' +
      '</div>',
    controller: 'LtLookCarouselCtrl',
    controllerAs: 'lookCarousel'
  };
}

App.directive('ltLookCarousel', [LtLookCarouselDirective]);
